// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Manrope:wght@400;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #1d4ed8;
  --primary-ghost: #eaf2ff;
  --text: #0f172a;
  --muted: #64748b;
  --border: #e2e8f0;
  --danger: #b42318;
  --bg: #f8fafc;
  --card: #ffffff;
  --shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
  --ring: rgba(59, 130, 246, 0.15);
  --radius: 18px;
}

* {
  box-sizing: border-box;
}

body {
  font-family: "Manrope", "Segoe UI", system-ui, -apple-system, Arial, sans-serif;
  background: var(--bg);
  margin: 0;
  color: var(--text);
}

.data-manager-embed {
  position: relative;
  display: flex;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  overflow: visible;
  padding-bottom: 0;
  --dataspace-scrollbar-thumb: #60758f;
  --dataspace-scrollbar-thumb-hover: #142642;
}

.data-manager-embed > .toolbar--title {
  flex: 0 0 auto;
}

.data-manager-embed .data-manager-layout {
  display: flex;
  height: auto;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
  margin-top: 0;
}

.data-manager-embed .data-manager-main {
  height: auto;
  min-height: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.data-manager-embed .pill-btn {
  background: #142642;
  color: #f8fafc;
  border: 1px solid #1d355a;
  border-radius: 14px;
  box-shadow: 0 8px 16px rgba(15, 23, 42, 0.16);
  transition: transform 0.05s ease, background 0.2s ease;
}

.data-manager-embed .pill-btn:hover {
  transform: translateY(-1px);
  background: #1d355a;
  color: #f8fafc;
}

.data-manager-embed .toolbar-version {
  color: #475569;
  background: #eef2ff;
  border: 1px solid #dbeafe;
}

.data-catalog-embed {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 0;
  --catalog-brand-navy: #142642;
  --catalog-brand-navy-hover: #1d355a;
  --catalog-brand-navy-ghost: #eaf2ff;
  --catalog-brand-navy-shadow: rgba(20, 38, 66, 0.22);
  --dataspace-scrollbar-thumb: #60758f;
  --dataspace-scrollbar-thumb-hover: #142642;
}

.data-catalog-embed > .catalog-header {
  flex: 0 0 auto;
}

.catalog-frame {
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.catalog-frame > div {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 0;
  flex-direction: column;
}

.data-catalog-embed .catalog-shell {
  display: flex;
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
}

.data-catalog-embed .catalog-actions {
  flex: 0 0 auto;
}

.solid-health-app-embed {
  position: relative;
  width: 100%;
  min-height: auto;
  padding-bottom: 0;
  --dataspace-scrollbar-thumb: #5f9b88;
  --dataspace-scrollbar-thumb-hover: #236b56;
}

.city-tours-embed {
  position: relative;
  width: 100%;
  min-height: auto;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  --dataspace-scrollbar-thumb: #6f91bd;
  --dataspace-scrollbar-thumb-hover: #1759ad;
}

.city-tours-embed > .city-tours-app {
  width: 100%;
  min-width: 0;
  flex: 1 1 auto;
}

.solid-health-questionnaire-embed {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
}

.solid-health-questionnaire-embed > .health-questionnaire-header {
  flex: 0 0 auto;
}

.solid-health-questionnaire-embed > .health-questionnaire-frame {
  width: 100%;
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
}

.health-questionnaire-frame {
  width: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  padding: 18px;
  border: 1px solid #e5e7eb;
  border-radius: 28px;
  background:
    radial-gradient(circle at top left, rgba(255, 255, 255, 0.96), rgba(243, 244, 246, 0.9)),
    linear-gradient(135deg, #f8fafc, #eef2f7);
  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.12);
}

.health-questionnaire-frame > .solid-health-questionnaire {
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
}

.solid-health-app-embed .app-shell--embedded {
  width: 100%;
  max-width: none;
  min-height: calc(var(--dataspace-scaled-vh, 100vh) - 230px);
  padding: 18px 18px 88px;
  background: #ffffff;
  border: 1px solid var(--border);
  border-radius: 16px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
}

.solid-health-app-embed .bottom-nav {
  position: absolute;
  left: 50%;
  right: auto;
  bottom: 18px;
  transform: translateX(-50%);
}

.catalog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.health-app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.health-questionnaire-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.city-tours-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 64px;
  padding: 13px 20px;
  border-color: #dce4ef;
  border-radius: 16px;
}

.city-tours-header .crumb {
  gap: 12px;
  color: #10284a;
  font-size: 1.45rem;
  font-weight: 800;
  letter-spacing: -0.025em;
}

.city-tours-header .crumb-icon {
  color: #1759ad;
  font-size: 1.25rem;
}

.city-tours-header .integrated-version {
  color: #10284a;
  background: #eaf0fb;
  border-color: #d8e2f0;
}

.integrated-version {
  margin-left: auto;
  color: #475569;
  font-size: 0.82rem;
  font-weight: 800;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 999px;
  background: #eef2ff;
  border: 1px solid #dbeafe;
}

.container {
  max-width: none;
  margin: 0;
  border-radius: 0;
  box-shadow: none;
  padding: 16px;
}

.layout > .main > .container {
  max-width: none !important;
  margin: 0 !important;
  padding-bottom: 16px;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: .75rem 0 1rem;
}

.toolbar--title {
  padding: 14px 18px;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: none;
  margin: .75rem 0 1rem;
  min-height: 56px;
  align-items: center;
  gap: 12px;
}

.toolbar--title .crumb {
  font-size: 1rem;
  line-height: 1.2;
}

.crumb {
  display: flex;
  align-items: center;
  gap: .5rem;
  color: #4a5a6a;
  font-weight: 700;
}

.crumb-icon {
  color: var(--primary);
}

.crumb-link {
  cursor: pointer;
  color: var(--primary);
}

.crumb-link:hover {
  text-decoration: underline;
}

.crumb-separator {
  margin: 0 .25rem;
  color: var(--muted);
}

.primary-actions {
  display: flex;
  gap: .6rem;
}

.pill-btn {
  display: inline-flex;
  align-items: center;
  gap: .5rem;
  padding: .5rem .75rem;
  background: var(--primary-ghost);
  color: var(--primary);
  border: 1px solid #dbe8ff;
  border-radius: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: transform .05s ease, background .2s ease;
}

.pill-btn:hover {
  transform: translateY(-1px);
}

.app-footer {
  position: relative;
  width: 100%;
  height: 88px;
  min-height: 88px;
  flex: 0 0 88px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.94);
  border-top: 1px solid var(--border);
  color: var(--muted);
  font-size: 0.875rem;
  font-weight: 700;
  z-index: 900;
  backdrop-filter: blur(10px);
}

.app-footer__legal {
  grid-column: 1;
  min-width: 0;
  padding-left: 24px;
}

.app-footer__identity {
  grid-column: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.app-footer__meta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.app-footer__funding {
  grid-column: 3;
  justify-self: end;
  margin-right: 24px;
  min-width: 0;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 18px;
  max-width: 100%;
  overflow: hidden;
}

.app-footer__funding img {
  display: block;
  max-height: 42px;
  max-width: 180px;
  object-fit: contain;
}

.app-footer__grant {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.15;
  white-space: nowrap;
  color: #475569;
  font-size: 0.72rem;
  font-weight: 700;
}

.app-footer__grant strong {
  color: #0f172a;
  font-size: 0.82rem;
  font-weight: 800;
}

.layout--sidebar-collapsed .app-footer {
  left: auto;
}

.app-footer__separator {
  color: #94a3b8;
}

.app-footer__version {
  color: #475569;
  font-size: 0.82rem;
  font-weight: 800;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 999px;
  background: #eef2ff;
  border: 1px solid #dbeafe;
}

.profile-panel {
  margin-top: 1rem;
  border: 0;
  border-radius: 14px;
  padding: 1rem;
  background: #fcfdff;
}


.loading-screen {
  min-height: calc(var(--dataspace-scaled-vh, 100vh) - 32px);
  display: grid;
  place-items: center;
  padding: 16px 12px;
  background: radial-gradient(1200px circle at 20% 10%, #eef2ff 0%, transparent 55%);
}

.loading-card {
  position: relative;
  width: min(620px, 92vw);
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid var(--border);
  border-radius: 22px;
  padding: 34px 32px 30px;
  box-shadow: 0 26px 60px rgba(15, 23, 42, 0.12);
  overflow: hidden;
}

.loading-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 6px;
  background: linear-gradient(120deg, #0f172a 0%, #0b4ea2 55%, #1d4ed8 100%);
}

.loading-card::after {
  content: "";
  position: absolute;
  right: -20%;
  top: -45%;
  width: 320px;
  height: 320px;
  background: radial-gradient(circle at 30% 30%, rgba(59, 130, 246, 0.22), transparent 65%);
  pointer-events: none;
}

.loading-content {
  position: relative;
  padding-top: 14px;
}

.loading-eyebrow {
  font-size: 0.74rem;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #64748b;
  font-weight: 800;
}

.loading-title {
  font-size: 1.5rem;
  font-weight: 800;
  margin-top: 10px;
}

.loading-subtitle {
  margin: 10px 0 20px;
  color: #475569;
  line-height: 1.55;
  max-width: 44ch;
}

.loading-particle-cloud {
  position: relative;
  height: 188px;
  border-radius: 0;
  overflow: hidden;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.loading-particle-cloud canvas {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}

.loading-particle-cloud--fallback {
  background:
    radial-gradient(circle at 34% 42%, rgba(15, 23, 42, 0.68) 0 2px, transparent 3px),
    radial-gradient(circle at 64% 58%, rgba(37, 99, 235, 0.6) 0 2px, transparent 3px),
    radial-gradient(circle at 52% 34%, rgba(96, 165, 250, 0.52) 0 2px, transparent 3px);
  background-size: 42px 42px, 54px 54px, 48px 48px;
}

.data-catalog-embed .modal .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 8px 15px !important;
  border: 1px solid transparent !important;
  border-radius: 8px !important;
  font-weight: 800;
  line-height: 1.2;
  box-shadow: none;
  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}

.data-catalog-embed .modal .btn-sm {
  min-height: 34px;
  padding: 6px 11px !important;
  font-size: 0.85rem;
}

.data-catalog-embed .modal .btn:hover:not(:disabled):not(.disabled) {
  transform: translateY(-1px);
}

.data-catalog-embed .modal .btn-primary,
.data-catalog-embed .modal .btn-success,
.data-catalog-embed .modal .btn-light,
.data-catalog-embed .modal .btn-outline-success:hover:not(:disabled):not(.disabled) {
  background: var(--catalog-brand-navy) !important;
  border-color: var(--catalog-brand-navy-hover) !important;
  color: #f8fafc !important;
  box-shadow: 0 10px 20px var(--catalog-brand-navy-shadow);
}

.data-catalog-embed .modal .btn-primary:hover:not(:disabled):not(.disabled),
.data-catalog-embed .modal .btn-success:hover:not(:disabled):not(.disabled),
.data-catalog-embed .modal .btn-light:hover:not(:disabled):not(.disabled),
.data-catalog-embed .modal .btn-outline-success:hover:not(:disabled):not(.disabled) {
  background: var(--catalog-brand-navy-hover) !important;
  border-color: var(--catalog-brand-navy-hover) !important;
  color: #ffffff !important;
  box-shadow: 0 14px 24px rgba(20, 38, 66, 0.26);
}

.data-catalog-embed .modal .btn-secondary,
.data-catalog-embed .modal .btn-outline-secondary,
.data-catalog-embed .modal .btn-outline-primary,
.data-catalog-embed .modal .btn-outline-success,
.data-catalog-embed .modal .provider-btn {
  background: #ffffff !important;
  border-color: #cbd5e1 !important;
  color: var(--catalog-brand-navy) !important;
  box-shadow: none;
}

.data-catalog-embed .modal .btn-secondary:hover:not(:disabled):not(.disabled),
.data-catalog-embed .modal .btn-outline-secondary:hover:not(:disabled):not(.disabled),
.data-catalog-embed .modal .btn-outline-primary:hover:not(:disabled):not(.disabled),
.data-catalog-embed .modal .provider-btn:hover:not(:disabled):not(.disabled) {
  background: var(--catalog-brand-navy-ghost) !important;
  border-color: var(--catalog-brand-navy-hover) !important;
  color: var(--catalog-brand-navy) !important;
}

.data-catalog-embed .modal .btn-danger {
  background: #b91c1c !important;
  border-color: #b91c1c !important;
  color: #ffffff !important;
  box-shadow: 0 10px 20px rgba(185, 28, 28, 0.2);
}

.data-catalog-embed .modal .btn-danger:hover:not(:disabled):not(.disabled) {
  background: #991b1b !important;
  border-color: #991b1b !important;
  box-shadow: 0 14px 24px rgba(153, 27, 27, 0.24);
}

.data-catalog-embed .modal .btn-outline-danger {
  background: #ffffff !important;
  border-color: #fecaca !important;
  color: #991b1b !important;
}

.data-catalog-embed .modal .btn-outline-danger:hover:not(:disabled):not(.disabled) {
  background: #b91c1c !important;
  border-color: #b91c1c !important;
  color: #ffffff !important;
}

.data-catalog-embed .modal .btn-link {
  min-height: auto;
  padding: 0 4px !important;
  border: 0 !important;
  background: transparent !important;
  color: var(--catalog-brand-navy) !important;
  box-shadow: none;
}

.data-catalog-embed .modal .btn-link:hover:not(:disabled):not(.disabled) {
  background: transparent !important;
  color: var(--catalog-brand-navy-hover) !important;
  transform: none;
}

.data-catalog-embed .modal .close {
  appearance: none;
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  float: none;
  width: 38px;
  height: 38px;
  padding: 0 !important;
  border: 0 !important;
  border-radius: 8px;
  background: transparent !important;
  color: #64748b !important;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
  opacity: 1;
  overflow: hidden;
  box-shadow: none;
  text-shadow: none;
}

.data-catalog-embed .modal .close:hover {
  background: var(--catalog-brand-navy-ghost) !important;
  color: var(--catalog-brand-navy) !important;
  transform: none;
}

.data-catalog-embed .modal .close span {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  border: 0;
  white-space: nowrap;
  clip: rect(0 0 0 0);
}

.data-catalog-embed .modal .close::before,
.data-catalog-embed .modal .close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 16px;
  height: 2px;
  border-radius: 999px;
  background: currentColor;
  pointer-events: none;
  transform-origin: center;
}

.data-catalog-embed .modal .close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.data-catalog-embed .modal .close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.data-catalog-embed .dataset-detail-action-button {
  border-color: var(--catalog-brand-navy-hover) !important;
  background: var(--catalog-brand-navy) !important;
  color: #f8fafc !important;
}

.data-catalog-embed .dataset-detail-action-button:hover {
  background: var(--catalog-brand-navy-hover) !important;
  color: #ffffff !important;
}

.data-catalog-embed .dataset-detail-action-button--delete {
  border-color: #fecaca !important;
  background: #ffffff !important;
  color: #991b1b !important;
}

.data-catalog-embed .dataset-detail-action-button--delete:hover {
  border-color: #b91c1c !important;
  background: #b91c1c !important;
  color: #ffffff !important;
}

.data-catalog-embed .detail-download-button,
.data-catalog-embed .pod-folder-modal-primary,
.data-catalog-embed .toggle-btn.active,
.data-catalog-embed .upload-button {
  background: var(--catalog-brand-navy) !important;
  color: #ffffff !important;
  box-shadow: 0 10px 20px var(--catalog-brand-navy-shadow);
}

.data-catalog-embed .detail-download-button:hover:not(:disabled),
.data-catalog-embed .pod-folder-modal-primary:hover:not(:disabled),
.data-catalog-embed .upload-button:hover {
  background: var(--catalog-brand-navy-hover) !important;
}

.data-catalog-embed .pod-folder-modal-secondary {
  color: var(--catalog-brand-navy) !important;
}

.data-catalog-embed .pod-folder-modal-secondary:hover:not(:disabled) {
  border-color: var(--catalog-brand-navy-hover) !important;
  background: var(--catalog-brand-navy-ghost) !important;
}

.data-catalog-embed .pod-folder-modal-close {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0 !important;
  line-height: 1;
}

.data-catalog-embed .pod-folder-modal-close i {
  display: block;
  line-height: 1;
}

@media (max-width: 720px) {
  .health-questionnaire-header {
    flex-wrap: wrap;
    padding: 12px 14px;
    border-radius: 14px;
  }

  .health-questionnaire-frame {
    min-height: 0;
    padding: 8px;
    border-radius: 18px;
  }

  .health-questionnaire-frame > .solid-health-questionnaire {
    min-height: 0;
    border-radius: 12px;
  }
}

/* City Tours fills the host's available row; its own panels manage scrolling. */
.city-tours-embed { height: 100%; min-height: 0; }
.city-tours-embed > .city-tours-app { min-height: 0; display: flex; flex-direction: column; }
.city-tours-embed .tours-shell { flex: 1 1; min-height: 0; display: flex; }
.city-tours-embed .city-tours-app--embedded .route-workspace { height: 100%; min-height: 0; }
@media (max-width: 700px) {
  .layout--city-tours > .main > .container { padding: 8px; }
  .city-tours-header { min-height: 48px; padding: 8px 12px; }
  .city-tours-header .crumb { font-size: 1.1rem; }
}

/* Keep legal links visible alongside the funding information at narrow widths. */
@media (max-width: 1100px) {
  .app-footer {
    grid-template-columns: minmax(0, 1fr) auto;
    height: auto;
    flex-basis: auto;
    padding: 12px 24px;
  }
  .app-footer__legal { padding-left: 0; }
  .app-footer__funding { grid-column: 1 / -1; margin-right: 0; flex-wrap: wrap; }
}

@media (max-width: 600px) {
  .app-footer { grid-template-columns: minmax(0, 1fr); padding: 12px; }
  .app-footer__identity { grid-column: 1; justify-self: start; }
  .app-footer__funding { justify-self: start; justify-content: flex-start; }
}

/* The responsive catalog owns its content; the existing title/version stays above it. */
.data-catalog-embed .catalog-app--embedded {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}
.data-catalog-embed .catalog-workspace {
  zoom: calc(1 / var(--dataspace-ui-scale, 1));
}
.data-catalog-embed .catalog-detail-inline .detail-download-button,
.data-catalog-embed .catalog-detail-inline .dataset-detail-request-button {
  background: #1769e8 !important;
  border-color: #1769e8 !important;
  color: #fff !important;
  box-shadow: none;
}
.data-catalog-embed .catalog-detail-inline .detail-download-button:hover:not(:disabled) {
  background: #125acb !important;
}

/* File content shares the catalog's readable size; the common header stays unchanged. */
.data-manager-embed .data-manager-layout,
.data-manager-embed .sdm-modal-overlay,
.data-manager-embed .sdm-context-menu {
  zoom: calc(1 / var(--dataspace-ui-scale, 1));
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,4CAA4C;EAC5C,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+EAA+E;EAC/E,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,sDAAsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,mCAAmC;EACnC,mCAAmC;EACnC,mDAAmD;EACnD,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB;;6CAE2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2DAA2D;EAC3D,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,qBAAqB;EACrB,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,mCAAmC;EACnC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,0DAA0D;EAC1D,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kFAAkF;AACpF;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,6DAA6D;EAC7D,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,WAAW;EACX,0EAA0E;AAC5E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,aAAa;EACb,yFAAyF;EACzF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;;;uFAGqF;EACrF,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,4BAA4B;EAC5B,wCAAwC;EACxC,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yHAAyH;AAC3H;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;EAIE,gDAAgD;EAChD,wDAAwD;EACxD,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;;;;EAIE,sDAAsD;EACtD,wDAAwD;EACxD,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;;;;;EAKE,8BAA8B;EAC9B,gCAAgC;EAChC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;;;;EAIE,sDAAsD;EACtD,wDAAwD;EACxD,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,kCAAkC;EAClC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;EACzB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sDAAsD;EACtD,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,wDAAwD;EACxD,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;;;EAIE,gDAAgD;EAChD,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;;;EAGE,sDAAsD;AACxD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wDAAwD;EACxD,sDAAsD;AACxD;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA,gFAAgF;AAChF,oBAAoB,YAAY,EAAE,aAAa,EAAE;AACjD,sCAAsC,aAAa,EAAE,aAAa,EAAE,sBAAsB,EAAE;AAC5F,iCAAiC,SAAO,EAAE,aAAa,EAAE,aAAa,EAAE;AACxE,+DAA+D,YAAY,EAAE,aAAa,EAAE;AAC5F;EACE,2CAA2C,YAAY,EAAE;EACzD,qBAAqB,gBAAgB,EAAE,iBAAiB,EAAE;EAC1D,4BAA4B,iBAAiB,EAAE;AACjD;;AAEA,iFAAiF;AACjF;EACE;IACE,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;EACA,qBAAqB,eAAe,EAAE;EACtC,uBAAuB,mBAAmB,EAAE,eAAe,EAAE,eAAe,EAAE;AAChF;;AAEA;EACE,cAAc,qCAAqC,EAAE,aAAa,EAAE;EACpE,wBAAwB,cAAc,EAAE,mBAAmB,EAAE;EAC7D,uBAAuB,mBAAmB,EAAE,2BAA2B,EAAE;AAC3E;;AAEA,wFAAwF;AACxF;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;AACA;EACE,4CAA4C;AAC9C;AACA;;EAEE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;;AAEA,wFAAwF;AACxF;;;EAGE,4CAA4C;AAC9C","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Manrope:wght@400;600;700;800&display=swap\");\n\n:root {\n  --primary: #1d4ed8;\n  --primary-ghost: #eaf2ff;\n  --text: #0f172a;\n  --muted: #64748b;\n  --border: #e2e8f0;\n  --danger: #b42318;\n  --bg: #f8fafc;\n  --card: #ffffff;\n  --shadow: 0 18px 40px rgba(15, 23, 42, 0.08);\n  --ring: rgba(59, 130, 246, 0.15);\n  --radius: 18px;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: \"Manrope\", \"Segoe UI\", system-ui, -apple-system, Arial, sans-serif;\n  background: var(--bg);\n  margin: 0;\n  color: var(--text);\n}\n\n.data-manager-embed {\n  position: relative;\n  display: flex;\n  height: 100%;\n  min-height: 0;\n  flex-direction: column;\n  overflow: visible;\n  padding-bottom: 0;\n  --dataspace-scrollbar-thumb: #60758f;\n  --dataspace-scrollbar-thumb-hover: #142642;\n}\n\n.data-manager-embed > .toolbar--title {\n  flex: 0 0 auto;\n}\n\n.data-manager-embed .data-manager-layout {\n  display: flex;\n  height: auto;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  overflow: hidden;\n  margin-top: 0;\n}\n\n.data-manager-embed .data-manager-main {\n  height: auto;\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n\n.data-manager-embed .pill-btn {\n  background: #142642;\n  color: #f8fafc;\n  border: 1px solid #1d355a;\n  border-radius: 14px;\n  box-shadow: 0 8px 16px rgba(15, 23, 42, 0.16);\n  transition: transform 0.05s ease, background 0.2s ease;\n}\n\n.data-manager-embed .pill-btn:hover {\n  transform: translateY(-1px);\n  background: #1d355a;\n  color: #f8fafc;\n}\n\n.data-manager-embed .toolbar-version {\n  color: #475569;\n  background: #eef2ff;\n  border: 1px solid #dbeafe;\n}\n\n.data-catalog-embed {\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  flex-direction: column;\n  overflow: hidden;\n  padding-bottom: 0;\n  --catalog-brand-navy: #142642;\n  --catalog-brand-navy-hover: #1d355a;\n  --catalog-brand-navy-ghost: #eaf2ff;\n  --catalog-brand-navy-shadow: rgba(20, 38, 66, 0.22);\n  --dataspace-scrollbar-thumb: #60758f;\n  --dataspace-scrollbar-thumb-hover: #142642;\n}\n\n.data-catalog-embed > .catalog-header {\n  flex: 0 0 auto;\n}\n\n.catalog-frame {\n  min-width: 0;\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n\n.catalog-frame > div {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  flex-direction: column;\n}\n\n.data-catalog-embed .catalog-shell {\n  display: flex;\n  height: 100%;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.data-catalog-embed .catalog-actions {\n  flex: 0 0 auto;\n}\n\n.solid-health-app-embed {\n  position: relative;\n  width: 100%;\n  min-height: auto;\n  padding-bottom: 0;\n  --dataspace-scrollbar-thumb: #5f9b88;\n  --dataspace-scrollbar-thumb-hover: #236b56;\n}\n\n.city-tours-embed {\n  position: relative;\n  width: 100%;\n  min-height: auto;\n  padding-bottom: 0;\n  display: flex;\n  flex-direction: column;\n  --dataspace-scrollbar-thumb: #6f91bd;\n  --dataspace-scrollbar-thumb-hover: #1759ad;\n}\n\n.city-tours-embed > .city-tours-app {\n  width: 100%;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.solid-health-questionnaire-embed {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n  padding-bottom: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.solid-health-questionnaire-embed > .health-questionnaire-header {\n  flex: 0 0 auto;\n}\n\n.solid-health-questionnaire-embed > .health-questionnaire-frame {\n  width: 100%;\n  min-width: 0;\n  min-height: 0;\n  flex: 1 1 auto;\n}\n\n.health-questionnaire-frame {\n  width: 100%;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 18px;\n  border: 1px solid #e5e7eb;\n  border-radius: 28px;\n  background:\n    radial-gradient(circle at top left, rgba(255, 255, 255, 0.96), rgba(243, 244, 246, 0.9)),\n    linear-gradient(135deg, #f8fafc, #eef2f7);\n  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.12);\n}\n\n.health-questionnaire-frame > .solid-health-questionnaire {\n  width: 100%;\n  height: 100%;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n  background: #ffffff;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);\n}\n\n.solid-health-app-embed .app-shell--embedded {\n  width: 100%;\n  max-width: none;\n  min-height: calc(var(--dataspace-scaled-vh, 100vh) - 230px);\n  padding: 18px 18px 88px;\n  background: #ffffff;\n  border: 1px solid var(--border);\n  border-radius: 16px;\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);\n}\n\n.solid-health-app-embed .bottom-nav {\n  position: absolute;\n  left: 50%;\n  right: auto;\n  bottom: 18px;\n  transform: translateX(-50%);\n}\n\n.catalog-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.health-app-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.health-questionnaire-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.city-tours-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 64px;\n  padding: 13px 20px;\n  border-color: #dce4ef;\n  border-radius: 16px;\n}\n\n.city-tours-header .crumb {\n  gap: 12px;\n  color: #10284a;\n  font-size: 1.45rem;\n  font-weight: 800;\n  letter-spacing: -0.025em;\n}\n\n.city-tours-header .crumb-icon {\n  color: #1759ad;\n  font-size: 1.25rem;\n}\n\n.city-tours-header .integrated-version {\n  color: #10284a;\n  background: #eaf0fb;\n  border-color: #d8e2f0;\n}\n\n.integrated-version {\n  margin-left: auto;\n  color: #475569;\n  font-size: 0.82rem;\n  font-weight: 800;\n  line-height: 1;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: #eef2ff;\n  border: 1px solid #dbeafe;\n}\n\n.container {\n  max-width: none;\n  margin: 0;\n  border-radius: 0;\n  box-shadow: none;\n  padding: 16px;\n}\n\n.layout > .main > .container {\n  max-width: none !important;\n  margin: 0 !important;\n  padding-bottom: 16px;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: .75rem 0 1rem;\n}\n\n.toolbar--title {\n  padding: 14px 18px;\n  border-radius: 18px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  box-shadow: none;\n  margin: .75rem 0 1rem;\n  min-height: 56px;\n  align-items: center;\n  gap: 12px;\n}\n\n.toolbar--title .crumb {\n  font-size: 1rem;\n  line-height: 1.2;\n}\n\n.crumb {\n  display: flex;\n  align-items: center;\n  gap: .5rem;\n  color: #4a5a6a;\n  font-weight: 700;\n}\n\n.crumb-icon {\n  color: var(--primary);\n}\n\n.crumb-link {\n  cursor: pointer;\n  color: var(--primary);\n}\n\n.crumb-link:hover {\n  text-decoration: underline;\n}\n\n.crumb-separator {\n  margin: 0 .25rem;\n  color: var(--muted);\n}\n\n.primary-actions {\n  display: flex;\n  gap: .6rem;\n}\n\n.pill-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: .5rem;\n  padding: .5rem .75rem;\n  background: var(--primary-ghost);\n  color: var(--primary);\n  border: 1px solid #dbe8ff;\n  border-radius: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform .05s ease, background .2s ease;\n}\n\n.pill-btn:hover {\n  transform: translateY(-1px);\n}\n\n.app-footer {\n  position: relative;\n  width: 100%;\n  height: 88px;\n  min-height: 88px;\n  flex: 0 0 88px;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n  align-items: center;\n  gap: 10px;\n  background: rgba(255, 255, 255, 0.94);\n  border-top: 1px solid var(--border);\n  color: var(--muted);\n  font-size: 0.875rem;\n  font-weight: 700;\n  z-index: 900;\n  backdrop-filter: blur(10px);\n}\n\n.app-footer__legal {\n  grid-column: 1;\n  min-width: 0;\n  padding-left: 24px;\n}\n\n.app-footer__identity {\n  grid-column: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.app-footer__meta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.app-footer__funding {\n  grid-column: 3;\n  justify-self: end;\n  margin-right: 24px;\n  min-width: 0;\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  gap: 18px;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.app-footer__funding img {\n  display: block;\n  max-height: 42px;\n  max-width: 180px;\n  object-fit: contain;\n}\n\n.app-footer__grant {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  line-height: 1.15;\n  white-space: nowrap;\n  color: #475569;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.app-footer__grant strong {\n  color: #0f172a;\n  font-size: 0.82rem;\n  font-weight: 800;\n}\n\n.layout--sidebar-collapsed .app-footer {\n  left: auto;\n}\n\n.app-footer__separator {\n  color: #94a3b8;\n}\n\n.app-footer__version {\n  color: #475569;\n  font-size: 0.82rem;\n  font-weight: 800;\n  line-height: 1;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: #eef2ff;\n  border: 1px solid #dbeafe;\n}\n\n.profile-panel {\n  margin-top: 1rem;\n  border: 0;\n  border-radius: 14px;\n  padding: 1rem;\n  background: #fcfdff;\n}\n\n\n.loading-screen {\n  min-height: calc(var(--dataspace-scaled-vh, 100vh) - 32px);\n  display: grid;\n  place-items: center;\n  padding: 16px 12px;\n  background: radial-gradient(1200px circle at 20% 10%, #eef2ff 0%, transparent 55%);\n}\n\n.loading-card {\n  position: relative;\n  width: min(620px, 92vw);\n  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid var(--border);\n  border-radius: 22px;\n  padding: 34px 32px 30px;\n  box-shadow: 0 26px 60px rgba(15, 23, 42, 0.12);\n  overflow: hidden;\n}\n\n.loading-card::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 6px;\n  background: linear-gradient(120deg, #0f172a 0%, #0b4ea2 55%, #1d4ed8 100%);\n}\n\n.loading-card::after {\n  content: \"\";\n  position: absolute;\n  right: -20%;\n  top: -45%;\n  width: 320px;\n  height: 320px;\n  background: radial-gradient(circle at 30% 30%, rgba(59, 130, 246, 0.22), transparent 65%);\n  pointer-events: none;\n}\n\n.loading-content {\n  position: relative;\n  padding-top: 14px;\n}\n\n.loading-eyebrow {\n  font-size: 0.74rem;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #64748b;\n  font-weight: 800;\n}\n\n.loading-title {\n  font-size: 1.5rem;\n  font-weight: 800;\n  margin-top: 10px;\n}\n\n.loading-subtitle {\n  margin: 10px 0 20px;\n  color: #475569;\n  line-height: 1.55;\n  max-width: 44ch;\n}\n\n.loading-particle-cloud {\n  position: relative;\n  height: 188px;\n  border-radius: 0;\n  overflow: hidden;\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n}\n\n.loading-particle-cloud canvas {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.loading-particle-cloud--fallback {\n  background:\n    radial-gradient(circle at 34% 42%, rgba(15, 23, 42, 0.68) 0 2px, transparent 3px),\n    radial-gradient(circle at 64% 58%, rgba(37, 99, 235, 0.6) 0 2px, transparent 3px),\n    radial-gradient(circle at 52% 34%, rgba(96, 165, 250, 0.52) 0 2px, transparent 3px);\n  background-size: 42px 42px, 54px 54px, 48px 48px;\n}\n\n.data-catalog-embed .modal .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 40px;\n  padding: 8px 15px !important;\n  border: 1px solid transparent !important;\n  border-radius: 8px !important;\n  font-weight: 800;\n  line-height: 1.2;\n  box-shadow: none;\n  transition: background 0.16s ease, border-color 0.16s ease, color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;\n}\n\n.data-catalog-embed .modal .btn-sm {\n  min-height: 34px;\n  padding: 6px 11px !important;\n  font-size: 0.85rem;\n}\n\n.data-catalog-embed .modal .btn:hover:not(:disabled):not(.disabled) {\n  transform: translateY(-1px);\n}\n\n.data-catalog-embed .modal .btn-primary,\n.data-catalog-embed .modal .btn-success,\n.data-catalog-embed .modal .btn-light,\n.data-catalog-embed .modal .btn-outline-success:hover:not(:disabled):not(.disabled) {\n  background: var(--catalog-brand-navy) !important;\n  border-color: var(--catalog-brand-navy-hover) !important;\n  color: #f8fafc !important;\n  box-shadow: 0 10px 20px var(--catalog-brand-navy-shadow);\n}\n\n.data-catalog-embed .modal .btn-primary:hover:not(:disabled):not(.disabled),\n.data-catalog-embed .modal .btn-success:hover:not(:disabled):not(.disabled),\n.data-catalog-embed .modal .btn-light:hover:not(:disabled):not(.disabled),\n.data-catalog-embed .modal .btn-outline-success:hover:not(:disabled):not(.disabled) {\n  background: var(--catalog-brand-navy-hover) !important;\n  border-color: var(--catalog-brand-navy-hover) !important;\n  color: #ffffff !important;\n  box-shadow: 0 14px 24px rgba(20, 38, 66, 0.26);\n}\n\n.data-catalog-embed .modal .btn-secondary,\n.data-catalog-embed .modal .btn-outline-secondary,\n.data-catalog-embed .modal .btn-outline-primary,\n.data-catalog-embed .modal .btn-outline-success,\n.data-catalog-embed .modal .provider-btn {\n  background: #ffffff !important;\n  border-color: #cbd5e1 !important;\n  color: var(--catalog-brand-navy) !important;\n  box-shadow: none;\n}\n\n.data-catalog-embed .modal .btn-secondary:hover:not(:disabled):not(.disabled),\n.data-catalog-embed .modal .btn-outline-secondary:hover:not(:disabled):not(.disabled),\n.data-catalog-embed .modal .btn-outline-primary:hover:not(:disabled):not(.disabled),\n.data-catalog-embed .modal .provider-btn:hover:not(:disabled):not(.disabled) {\n  background: var(--catalog-brand-navy-ghost) !important;\n  border-color: var(--catalog-brand-navy-hover) !important;\n  color: var(--catalog-brand-navy) !important;\n}\n\n.data-catalog-embed .modal .btn-danger {\n  background: #b91c1c !important;\n  border-color: #b91c1c !important;\n  color: #ffffff !important;\n  box-shadow: 0 10px 20px rgba(185, 28, 28, 0.2);\n}\n\n.data-catalog-embed .modal .btn-danger:hover:not(:disabled):not(.disabled) {\n  background: #991b1b !important;\n  border-color: #991b1b !important;\n  box-shadow: 0 14px 24px rgba(153, 27, 27, 0.24);\n}\n\n.data-catalog-embed .modal .btn-outline-danger {\n  background: #ffffff !important;\n  border-color: #fecaca !important;\n  color: #991b1b !important;\n}\n\n.data-catalog-embed .modal .btn-outline-danger:hover:not(:disabled):not(.disabled) {\n  background: #b91c1c !important;\n  border-color: #b91c1c !important;\n  color: #ffffff !important;\n}\n\n.data-catalog-embed .modal .btn-link {\n  min-height: auto;\n  padding: 0 4px !important;\n  border: 0 !important;\n  background: transparent !important;\n  color: var(--catalog-brand-navy) !important;\n  box-shadow: none;\n}\n\n.data-catalog-embed .modal .btn-link:hover:not(:disabled):not(.disabled) {\n  background: transparent !important;\n  color: var(--catalog-brand-navy-hover) !important;\n  transform: none;\n}\n\n.data-catalog-embed .modal .close {\n  appearance: none;\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  float: none;\n  width: 38px;\n  height: 38px;\n  padding: 0 !important;\n  border: 0 !important;\n  border-radius: 8px;\n  background: transparent !important;\n  color: #64748b !important;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1;\n  opacity: 1;\n  overflow: hidden;\n  box-shadow: none;\n  text-shadow: none;\n}\n\n.data-catalog-embed .modal .close:hover {\n  background: var(--catalog-brand-navy-ghost) !important;\n  color: var(--catalog-brand-navy) !important;\n  transform: none;\n}\n\n.data-catalog-embed .modal .close span {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  border: 0;\n  white-space: nowrap;\n  clip: rect(0 0 0 0);\n}\n\n.data-catalog-embed .modal .close::before,\n.data-catalog-embed .modal .close::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 16px;\n  height: 2px;\n  border-radius: 999px;\n  background: currentColor;\n  pointer-events: none;\n  transform-origin: center;\n}\n\n.data-catalog-embed .modal .close::before {\n  transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.data-catalog-embed .modal .close::after {\n  transform: translate(-50%, -50%) rotate(-45deg);\n}\n\n.data-catalog-embed .dataset-detail-action-button {\n  border-color: var(--catalog-brand-navy-hover) !important;\n  background: var(--catalog-brand-navy) !important;\n  color: #f8fafc !important;\n}\n\n.data-catalog-embed .dataset-detail-action-button:hover {\n  background: var(--catalog-brand-navy-hover) !important;\n  color: #ffffff !important;\n}\n\n.data-catalog-embed .dataset-detail-action-button--delete {\n  border-color: #fecaca !important;\n  background: #ffffff !important;\n  color: #991b1b !important;\n}\n\n.data-catalog-embed .dataset-detail-action-button--delete:hover {\n  border-color: #b91c1c !important;\n  background: #b91c1c !important;\n  color: #ffffff !important;\n}\n\n.data-catalog-embed .detail-download-button,\n.data-catalog-embed .pod-folder-modal-primary,\n.data-catalog-embed .toggle-btn.active,\n.data-catalog-embed .upload-button {\n  background: var(--catalog-brand-navy) !important;\n  color: #ffffff !important;\n  box-shadow: 0 10px 20px var(--catalog-brand-navy-shadow);\n}\n\n.data-catalog-embed .detail-download-button:hover:not(:disabled),\n.data-catalog-embed .pod-folder-modal-primary:hover:not(:disabled),\n.data-catalog-embed .upload-button:hover {\n  background: var(--catalog-brand-navy-hover) !important;\n}\n\n.data-catalog-embed .pod-folder-modal-secondary {\n  color: var(--catalog-brand-navy) !important;\n}\n\n.data-catalog-embed .pod-folder-modal-secondary:hover:not(:disabled) {\n  border-color: var(--catalog-brand-navy-hover) !important;\n  background: var(--catalog-brand-navy-ghost) !important;\n}\n\n.data-catalog-embed .pod-folder-modal-close {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  padding: 0 !important;\n  line-height: 1;\n}\n\n.data-catalog-embed .pod-folder-modal-close i {\n  display: block;\n  line-height: 1;\n}\n\n@media (max-width: 720px) {\n  .health-questionnaire-header {\n    flex-wrap: wrap;\n    padding: 12px 14px;\n    border-radius: 14px;\n  }\n\n  .health-questionnaire-frame {\n    min-height: 0;\n    padding: 8px;\n    border-radius: 18px;\n  }\n\n  .health-questionnaire-frame > .solid-health-questionnaire {\n    min-height: 0;\n    border-radius: 12px;\n  }\n}\n\n/* City Tours fills the host's available row; its own panels manage scrolling. */\n.city-tours-embed { height: 100%; min-height: 0; }\n.city-tours-embed > .city-tours-app { min-height: 0; display: flex; flex-direction: column; }\n.city-tours-embed .tours-shell { flex: 1; min-height: 0; display: flex; }\n.city-tours-embed .city-tours-app--embedded .route-workspace { height: 100%; min-height: 0; }\n@media (max-width: 700px) {\n  .layout--city-tours > .main > .container { padding: 8px; }\n  .city-tours-header { min-height: 48px; padding: 8px 12px; }\n  .city-tours-header .crumb { font-size: 1.1rem; }\n}\n\n/* Keep legal links visible alongside the funding information at narrow widths. */\n@media (max-width: 1100px) {\n  .app-footer {\n    grid-template-columns: minmax(0, 1fr) auto;\n    height: auto;\n    flex-basis: auto;\n    padding: 12px 24px;\n  }\n  .app-footer__legal { padding-left: 0; }\n  .app-footer__funding { grid-column: 1 / -1; margin-right: 0; flex-wrap: wrap; }\n}\n\n@media (max-width: 600px) {\n  .app-footer { grid-template-columns: minmax(0, 1fr); padding: 12px; }\n  .app-footer__identity { grid-column: 1; justify-self: start; }\n  .app-footer__funding { justify-self: start; justify-content: flex-start; }\n}\n\n/* The responsive catalog owns its content; the existing title/version stays above it. */\n.data-catalog-embed .catalog-app--embedded {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n.data-catalog-embed .catalog-workspace {\n  zoom: calc(1 / var(--dataspace-ui-scale, 1));\n}\n.data-catalog-embed .catalog-detail-inline .detail-download-button,\n.data-catalog-embed .catalog-detail-inline .dataset-detail-request-button {\n  background: #1769e8 !important;\n  border-color: #1769e8 !important;\n  color: #fff !important;\n  box-shadow: none;\n}\n.data-catalog-embed .catalog-detail-inline .detail-download-button:hover:not(:disabled) {\n  background: #125acb !important;\n}\n\n/* File content shares the catalog's readable size; the common header stays unchanged. */\n.data-manager-embed .data-manager-layout,\n.data-manager-embed .sdm-modal-overlay,\n.data-manager-embed .sdm-context-menu {\n  zoom: calc(1 / var(--dataspace-ui-scale, 1));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
